import { hbs } from 'ember-cli-htmlbars';
export default hbs("<NwNavbar />\n\n<NwPageLocationBanner>\n  <:first><LinkTo @route=\"plans\">Plans</LinkTo></:first>\n</NwPageLocationBanner>\n\n<Loading::LargeHorizontal />")